<template>
    <div class="lightgray-content p-2 small-font mb-2 pb-2 border-bottom" :key="index">
        <div class="d-flex justify-content-between align-items-center">
            <div class="m-2">
                <strong class="mb-2 red text-uppercase">
                    {{ $t('parcelas.n_parcela') }}
                    {{ parcela.numero }}
                </strong>
                <div class="mt-1">
                    <label class="mb-1 text-bold">
                        Zona:
                    </label>
                    {{ parcela.zona.nombre }}
                </div>
            </div>
            <div class="d-flex flex-column align-items-center ml-3">
                <div class="text-center mr-2">
                    <label class="m-0">{{ $t("gracias.precio") }}</label><br />
                    <span class="h2">
                        <span 
                            class="h1 m-0" 
                        >
                            {{ parcela.precio | formatear_precio }}
                        </span>
                    </span>
                </div>
                <div v-if="parcela.pdf_url" class="mt-3">
                    <a
                        :href="parcela.pdf_url"
                        class="button button-red button-xs"
                        target="_blank"
                    >
                        DESCARGAR PDF
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            parcela: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        }
    }
</script>